import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import {
  BookingWizardDataAtom,
  CurrentRequestGroupIndexAtom,
  CurrentBookingWizardStepAtom,
  isAddingNewGuestAtom,
  ListOfBookingWizardStepsAtom,
  originalListOfBookingWizardStepsAtom,
} from "../../stores";

type InitializeBookingWizardAtomPayload = {
  initialBookingWizardData: BookingWizard.BookingWizardData;
  requiredWizardSteps: BookingWizard.BookingWizardStepTitle[];
};

export const initializeBookingWizardAtom = atom(
  null,
  (get, set, payload: InitializeBookingWizardAtomPayload) => {
    set(BookingWizardDataAtom, payload.initialBookingWizardData);
    set(ListOfBookingWizardStepsAtom, payload.requiredWizardSteps);
    set(originalListOfBookingWizardStepsAtom, payload.requiredWizardSteps);
    set(CurrentBookingWizardStepAtom, payload.requiredWizardSteps[0]);
    set(CurrentRequestGroupIndexAtom, 0);
    set(isAddingNewGuestAtom, false);
  }
);
